import Vue from 'vue';
import Router from 'vue-router';
import Question from './components/steps/Question'
import Result from './components/Result'

Vue.use(Router);
const myRoutes = [
        
  {
      path: '/',
      redirect: '/1',
  },
  {
    name: 'question-1',
    path: '/1',
    component: Question,
  },
  {
    name: 'question-2',
    path: '/2',
    component: Question,
  },
  {
    name: 'question-3',
    path: '/3',
    component: Question,
  },
  {
    name: 'question-4',
    path: '/4',
    component: Question,
  },
  {
    name: 'question-5',
    path: '/5',
    component: Question,
  },
  
  {
    name: 'result',
    path: '/6',
    component: Result,
  },
];

const router = new Router({
  //mode: 'abstract',
    routes: myRoutes,
});


export default router;


// WEBPACK FOOTER //
// ./src/router.js